import React from 'react';
import TextField from 'material-ui/TextField';

const TitleStep = ({ fields, assignRef, onInputKeyDown }) => (
  <div className="step-content">
    <h2>Sniðugur titill!</h2>
    <p>Lýstu eign þinni í stuttum máli.</p>
    <div className="input-wrapper columns">
      <TextField
        {...fields.title}
        ref={assignRef ? c => assignRef('title', c) : null}
        onKeyDown={onInputKeyDown}
        maxLength={50}
        hintText="Sláðu hér inn titil"
        fullWidth
      />
      <span className="word-count">{fields.title.value.length} / 50</span>
    </div>
  </div>
);

TitleStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
  onInputKeyDown: React.PropTypes.func,
};

export default TitleStep;



// WEBPACK FOOTER //
// ./src/browser/steps/TitleStep/TitleStep.js